import { FunctionComponent } from 'react'
import Modal from '@/components/Modal'
import { Button } from '@conexasaude/hero'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useRealtimeAttendanceContext } from '@/modules/RealtimeAttendance/contexts/RealtimeAttendanceContext'
import { useTheme } from '@emotion/react'

const ScheduledCallStartedModal: FunctionComponent<{
  hookSuccess()
}> = ({ hookSuccess }) => {
  const { closeModal } = useModalContext()
  const {
    realtimeAttendance: { nextScheduled },
  } = useRealtimeAttendanceContext()
  const { colors } = useTheme()

  return (
    <Modal id="SCHEDULED_CALL_STARTED">
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <p className="w-100 mb-5">
            <span
              className="text-capitalize"
              css={{ color: colors.primary[500] }}
            >
              {nextScheduled?.professionalName?.toLowerCase()}
            </span>{' '}
            já está aguardando por você. Vamos começar?
          </p>
          <div className="d-flex justify-content-end flex-lg-row flex-column-reverse w-100 footer-modal-buttons">
            <Button
              id="SalaDeEsperaAgendado-IniciarConsulta-CTA_IniciarConsulta"
              onClick={() => {
                closeModal()
                hookSuccess()
              }}
            >
              Iniciar consulta
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ScheduledCallStartedModal
